<template>
  <HeaderPopup
    class="small-cart"
    :is-popup-visible="isPopupVisible"
    :is-empty-popup="!cartSort.products.length"
    type="cart"
  >
    <div class="small-cart__cart" v-if="cartSort.products.length">
      <div class="small-cart__title">{{ $t('cart_title') }}</div>
      <ul class="small-cart__products-list custom-scrollbar">
        <li class="small-cart-product" v-for="product in cartSort.products" :key="product.id">
          <cart-item :product="product" is-small-cart-item></cart-item>
        </li>
      </ul>
      <div class="small-cart-total">
        <div class="small-cart-total__info">
          <span class="small-cart-total__price-text">{{ $t('cart_total') }} </span>
          <span class="small-cart-total__price">{{ cartSort.cart['cartCost'] }} </span>
          <del v-if="fullOriginalCost > cartSort.cart.originCost" class="small-cart-total__full-price">
            {{ fullOriginalCost | currencyFormatter }} {{ cartSort.cart.currency }}
          </del>
        </div>
        <div class="small-cart-total__actions">
          <button v-if="!isManager && config.isEnabledOneClickAndCallback" @click="showQuickOrderModal" class="small-cart-total__btn small-cart-total__btn--inverse">
            {{ $t('quick_order') }}
          </button>
          <a @click="pushAnalyticEventNavToCheckout" :href="computedCheckoutData.link" class="small-cart-total__btn">
            {{ computedCheckoutData.label }}
          </a>
        </div>
        <button class="small-cart__open-cart link link--pseudo" @click="showCartModal">
          {{ $t('cart_go_to_modal') }}
        </button>
      </div>
    </div>
  </HeaderPopup>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import CurrencyFormatter from '../../filters/CurrencyFormatter'
import HeaderPopup from '@/components/helpers/HeaderPopup'
import { GoogleTagManagerService } from '@/services/AnalyticService'
import CartItem from '@/components/cart/cart-item/CartItem'

export default {
  name: 'HeaderCartPopupNew',
  components: { HeaderPopup, CartItem },
  props: {
    isPopupVisible: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix', 'cartSort', 'isCheckoutAsClient', 'isManager', 'cartModalName']),
    ...mapState({
      cart: state => state.cart.cart,
      config: state => state.init.config
    }),
    computedCheckoutData () {
      let data = {
        link: this.urlLanguagePrefix + '/checkout/',
        label: this.$t('cart_buy')
      }

      if (this.isCheckoutAsClient && this.isManager) {
        data = {
          link: this.urlLanguagePrefix + '/manager-checkout/',
          label: this.$t('checkout_as_client')
        }
      }

      return data
    },
    fullOriginalCost () {
      return this.cart.discountInfo?.fullOriginalCost ?? 0
    }
  },
  methods: {
    showCartModal () {
      this.$modal.show(this.cartModalName)
    },
    showQuickOrderModal () {
      this.$modal.show('quick-order-modal', { type: 'one-click', orderProductsFromCart: true })
    },
    pushAnalyticEventNavToCheckout () {
      GoogleTagManagerService.pushToDatalayer({
        'event': 'nav-to-cart-gtm-event',
        'eventCategory': 'nav_to_cart'
      })
    }
  },
  filters: {
    CurrencyFormatter
  }
}
</script>

<style scoped lang="sass">

.small-cart__cart
  padding: 35px 0 20px 25px

.small-cart__title
  font-weight: 500
  font-size: 24px
  line-height: 19px
  margin-bottom: 5px

.small-cart__text
  font-weight: 400 //Rubik 300
  font-size: 14px
  line-height: 17px
  text-align: center
  margin: 10px 0 20px

.small-cart__img
  width: 100px
  height: 84px
  background-image: url(/img/svgo/cart/cart.svg)
  background-repeat: no-repeat
  background-size: contain
  margin: 0 auto

.small-cart__products-list
  +list-unstyled
  max-height: 335px
  padding-right: 25px
  overflow-y: auto

.small-cart-product
  display: flex
  flex-flow: row nowrap
  padding: 20px 0 15px
  border-bottom: 1px solid #e1e1e1
  &:first-child ::v-deep .approve-remove
    top: 150%

.small-cart-product__total-price
  margin-left: auto
  font-weight: 400
  font-size: 16px
  line-height: 19px
  padding-right: 10px

.small-cart-product__price
  width: 72px
  margin-right: 50px

.small-cart-total
  display: flex
  flex-flow: column
  margin-top: 20px
  padding-right: 25px

.small-cart-total__price
  font-size: 22px
  font-weight: 500
  margin: 0 20px

.small-cart-total__price-text
  font-weight: 500
  font-size: 18px

.small-cart-total__full-price
  text-decoration-color: $main-color
  color: $placeholder-color
  font-size: 16px

.small-cart-total__actions
  display: flex
  flex-flow: row nowrap
  justify-content: space-between
  align-items: center
  margin-top: 20px

.small-cart-total__btn
  display: flex
  align-items: center
  justify-content: center
  height: 37px
  font-size: 14px
  font-weight: 500
  border: 1px solid $main-color
  border-radius: 3px
  background-color: $main-color
  padding: 0 12px
  color: $white-text-color
  transition: .4s
  cursor: pointer
  width: 48%
  white-space: nowrap
  text-align: center

  &:hover
    background-color: $main-color--hover

  &--inverse
    background-color: transparent
    color: $text-color

    &:hover
      background-color: $btn-bg
      color: $white-text-color

.small-cart__open-cart
  display: block
  margin: 20px auto 0
  font-weight: 400 //Rubik 300
  font-size: 14px
  line-height: 17px
  text-align: center
  background-color: transparent

</style>
